/**
 * Primary schools use "class teacher"; secondary/combined use "form teacher".
 * Same homeroom duties; labels follow school type.
 */

export function isPrimarySchoolType(schoolType) {
    const t = String(schoolType || "").trim();
    return t === "Primary" || /^primary$/i.test(t);
}

export function getHomeroomTeacherTerm(schoolType) {
    const primary = isPrimarySchoolType(schoolType);
    if (primary) {
        return {
            primary: true,
            roleValue: "Class Teacher",
            roleTitle: "Class teacher",
            roleTitleCaps: "Class Teacher",
            assignOnClass: "Class teacher",
            navSection: "Class teacher",
            chipPrefix: "Class teacher",
            plural: "class teachers",
            enrollHint: "class-teacher",
            marksSentTo: "class teacher",
            theRole: "class teacher",
        };
    }
    return {
        primary: false,
        roleValue: "Form Teacher",
        roleTitle: "Form teacher",
        roleTitleCaps: "Form Teacher",
        assignOnClass: "Form teacher",
        navSection: "Form teacher",
        chipPrefix: "Form teacher",
        plural: "form teachers",
        enrollHint: "form-teacher",
        marksSentTo: "form teacher",
        theRole: "form teacher",
    };
}

export function getHomeroomTeacherTermFromUser(user) {
    const schoolType = user?.schoolType ?? user?.school?.schoolType;
    return getHomeroomTeacherTerm(schoolType);
}
